import React, { useState } from 'react';
import cities from '../utils/cities.json';
import Form from 'react-bootstrap/Form';


const CitySelect = ({ onCityChange, className }) => {
  const [selectedCity, setSelectedCity] = useState('');

  const handleChange = (event) => {
    const city = event.target.value;
    setSelectedCity(city);
    onCityChange(city);
  };

  return ( 
    <div className={className}>
      <Form.Select value={selectedCity} onChange={handleChange}>
        <option key="" value="" disabled>
            例如: 台北
        </option>
        {cities.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Form.Select>
      <label htmlFor="floatingInput">選擇地區</label>
    </div>
  );
};

export default CitySelect;